export enum PermissionEnum {
    // Academic Awards
    AcademicAwardsSchool = 1298,
    AcademicAwardsDistrict = 2350,

    // Academic History
    AcademicHistoryAddEdit = 1299,
    AcademicHistoryView = 1296,
    AcademicHistoryViewAddEdit = 1294,
    AcademicHistory = 2084,

    // AcademicProgress
    AddEditEducationPlan = 2170,
    AddEditCreditAcquisition = 2173,
    AddEditGraduationPlan = 2385,
    AddEditProficiencyProgress = 2591,

    // Attendance
    AddEditPeriodicAttendance = 1128,
    AddEditTeacherSubjectAttendance = 1195,

    // Behavior Events
    BehaviorEventAddEdit = 1199,
    BehaviorEventQuickEntry = 2204,
    BehaviorEventView = 1217,
    BehaviorEventSearchStudent = 1228,
    BehaviorEventViewDetails = 1231,

    // Behavior Interventions
    BehaviorInterventionViewAll = 2575,
    BehaviorInterventionAddEditAll = 2576,
    BehaviorInterventionViewMy = 2577,
    BehaviorInterventionAddEditMy = 2578,
    BehaviorInterventionDeleteAll = 2579,
    BehaviorInterventionDeleteMy = 2580,

    // Behavior Referrals
    AcceptDisciplineReferrals = 1800,
    AddEditDisciplineReferral = 1798,
    AllowEditDeleteReferral = 2521,
    ViewDisciplineReferral = 1823,
    ViewAllDisciplineReferrals = 2558,

    // Course Verification
    CourseVerificationAddEdit = 1721,
    CourseVerificationView = 1724,

    // CommunicationLog
    AddEditMyCommunicationLogCounselor = 2336,
    AddEditAllCommunicationLogsCounselor = 2337,
    AddEditMyCommunicationLogStudentRecord = 2340,
    AddEditAllCommunicationLogsStudentRecord = 2341,
    AddEditMyCommunicationLogMyStudents = 2344,
    AddEditAllCommunicationLogsMyStudents = 2345,
    ViewMyCommunicationLogCounselor = 2338,
    ViewAllCommunicationLogsCounselor = 2339,
    ViewMyCommunicationLogStudentRecord = 2342,
    ViewAllCommunicationLogsStudentRecord = 2343,
    ViewMyCommunicationLogMyStudents = 2346,
    ViewAllCommunicationLogsMyStudents = 2347,
    ViewCommunicationLogsCounselorFunctions = 2335,
    ViewConfidentialNotes = 2560,
    AddEditConfidentialNotes = 2561,
    DeleteMyCommunicationLog = 2562,
    DeleteAllCommunicationLogs = 2563,

    // e-Form Permissions
    eFormAddEditCategory = 2547,
    eFormAddEditTeplate = 2548,
    eFormAddEditAllForms = 2549,
    eFormAddEditAllTranslations = 2550,
    eFormEditInUseForms = 2551,
    eFormViewAllForms = 2552,
    eFormRevieApproveAllForms = 2553,
    eFormAddEditForm = 2554,
    eFormViewForm = 2555,
    eFormAddEditTranslation = 2556,
    eFormReviewApproveForm = 2557,
    eFormViewAllAggregateData= 2593,
    eFormViewAggregateData = 2595,
    eFormCompleteAllStudentForms = 2594,
    eFormCompleteStudentForms= 2596,

    // Programs and Services
    StudentGeneralProfileStudentPrograms = 2573,

    // scheduling 360 permissions
    AddCourseRequestRead = 616,
    AddEditClassrooms = 1797,
    AddEditCustomSchedulingProperties = 2565,
    AddEditCycleCodes = 1458,
    AddEditDistrictBellSchedule = 1449,
    AddEditDistrictCycleCodes = 1450,
    AddEditEmployeeDepartments = 1846,
    AddEditLinkedClasses = 1463,
    AddEditLocalRoomGroups = 1409,
    AddEditSchedulingGroupCategory = 2566,
    AddEditSchoolBellSchedule = 1455,
    AddEditSchoolCycleCodes = 1458,
    AddEditStudentClassGroups = 1460,
    AddEditStudentGlobalAvoidedStudents = 1426,
    AddEditStudentGlobalAvoidedTeachers = 1430,
    AddEditStudentGlobalAvoidedPeriods= 1434,
    AddEditStudentLocalAvoidedPeriods = 1436,
    AddEditStudentLocalAvoidedStudents= 1428,
    AddEditStudentLocalAvoidedTeachers = 1432,
    AddEditSubjectSections = 1466,
    AddEditTeacherBasicInformation = 1416,
    AddEditTeacherGlobalAvoidedStudents = 1417,
    AddEditTeacherLocalAvoidedPeriods = 1423,
    AllowConflictOverrides = 2348,
    ClearOthersWorkingSchedule= 2517,
    CourseRequestRead = 606,
    DeleteDistrictBellSchedule = 1403,
    DeleteLinkedClasses = 1464,
    DeleteSchoolBellSchedule = 1474,
    DeleteSections = 1467,
    DeleteTeacherLocalAvoidedPeriods = 1424,
    DistrictCourseRequestSetupRead = 2534,
    DistrictCourseRequestSetupWrite = 2535,
    EditFolderSettings = 1454,
    EditGlobalSettings = 1441,
    EditMasterSchedule = 1476,
    EmployeeSubjectArea = 221,
    GradeLevelCourseRequestSetupRead = 871,
    GradeLevelCourseRequestSetupWrite = 872,
    MassCourseRequest = 1078,
    MassRemoveCourseRequests = 1859,
    PerformStudentScheduling = 1482,
    RunAutoScheduler = 1478,
    ScheduleStudents = 1468,
    SchoolCourseRequestSetupRead = 608,
    SchoolCourseRequestSetupWrite = 609,
    ViewCustomSchedulingProperties = 2564,
    ViewDistrictBellSchedule = 1452,
    ViewDistrictCycleCodes = 1451,
    ViewMasterSchedule = 1475,
    ViewRoomResources = 1405,
    ViewSchedulingFolders = 1445,
    ViewSchoolBellSchedule = 1473,
    ViewSchoolCycleCodes = 1456,
    ViewStudentClassGroups = 1459,
    ViewStudentPreferences = 1425,
    ViewStudentScheduler = 1481,
    ViewSubjectSections = 1465,
    ViewTeacherPreferences = 1415,


    // Student Notes
    StudentNotesCounselorAddEdit = 2103,
    StudentNotesMyStudentsAddEdit = 2101,
    StudentNotesStudentRecordAddEdit = 2099,
    StudentNotesCounselorView = 2102,
    StudentNotesMyStudentsView = 2100,
    StudentNotesStudentRecordView = 2098,

    // Team Attendance
    AddEditTeacherTeamAttendance = 1197,

}
